import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AdhocAdvancePayment  {
    _originalTypeClassName = "zERP.BO.AdhocAdvancePayment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AdhocAdvancePayment.translate = translateService;
}
this.Type = new Domain.AdhocAdvancePaymentType();
this.Id = null;
this.Status = null;
this.SubmitionDate = null;
this.Amount = null;
this.PaymentDate = null;
this.ClearanceDate = null;
this.CancelationReason = null;
this.CancelationDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Status:any;
SubmitionDate:any;
Amount:any;
PaymentDate:any;
ClearanceDate:any;
CancelationReason:any;
CancelationDate:any;
EmployeeContract:any;
Type:any;
ClearedOn:any;
SalaryPeriod:any;
CreatedBy:any;
PayrollPeriod:any;
ExpenseInvoice:any;
CanceledBy:any;
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setClearedOn = ($this, value) => {
var oldValue = $this.ClearedOn;
$this.ClearedOn = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeePayroll.removeAdhocAdvancePayments(oldValue, $this);
}
Domain.EmployeePayroll.addAdhocAdvancePayments(value, $this);
}
}
static setSalaryPeriod = ($this, value) => {
var oldValue = $this.SalaryPeriod;
$this.SalaryPeriod = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setPayrollPeriod = ($this, value) => {
var oldValue = $this.PayrollPeriod;
$this.PayrollPeriod = value;
if (value != null) {
}
}
static setExpenseInvoice = ($this, value) => {
var oldValue = $this.ExpenseInvoice;
$this.ExpenseInvoice = value;
if (value != null) {
}
}
static setCanceledBy = ($this, value) => {
var oldValue = $this.CanceledBy;
$this.CanceledBy = value;
if (value != null) {
}
}

static CanBeCanceled($this: any): any{return $this?.Status == Domain.AdhocAdvancePaymentStatus.Payment;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}